import history from 'history/browser'
import React from 'react'
import { Bloc, Header } from '../ImportAll'

export default function ViewNotExist() {
    return (
        <div>
            <Header
                title="Ou souhaitez vous aller ?"
                subTitle="Cette page n'existe pas ou plus ..."
            />
            <div
                className="Container"
                onClick={(e) =>
                    history.push('/tunnelmobile/?view=0', { targetView: 0 })
                }
            >
                <div className="separator"></div>
                <Bloc
                    key="key227"
                    nbcolumn={1}
                    onetextline
                    textsimple1="Retour a l'acceuil"
                />
                <div className="separator"></div>
                <div className="separator"></div>
                <div className="separator"></div>
            </div>
        </div>
    )
}
